(function stickyNavBarButton(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  const previousStickyNavBarButton = global.NewHomeSource.StickyNavBarButton;
  const stickyNav = document.querySelector('[data-details-container] [data-sticky-nav-bar]');
  const buttonCtaContainer = document.querySelector('[data-sticky-button-container]');
  const barItems = document.querySelector('[sticky-bar-scroll]');
  const containerItems = document.querySelector('[data-sticky-bar],[data-stickybar]');
  const moveArrow = document.querySelector('[sticky-arrow-right]');

  function observerStickyNavBar() {
    const options = {
      root: null,
      rootMargin: '0%',
      threshold: 0
    };

    const observer = new IntersectionObserver(((entries) => {
      if (!entries[0].isIntersecting && entries[0].boundingClientRect.top <= 0) {
        if (buttonCtaContainer) {
          buttonCtaContainer.removeAttribute('hidden');
        }
        stickyNav.classList.add('nhs-u-sticky');

        // Validations added to avoid issues in Plans/Specs Detail pages since
        // the scroll functionality is not used there.
        if (!barItems) {
          return;
        }

        if (moveArrow) {
          moveArrow.style.right = '194px';
        }

        if (moveArrow) {
          moveArrow.style.right = '150px';
        }

        if (containerItems) {
          containerItems.dispatchEvent(new Event('recalculateLimits'));
          observer.unobserve(stickyNav);
        }
      }
    }),
    options
    );
    observer.observe(stickyNav);
  }
  /**
   * @constructs NewHomeSource.StickyNavBarButton
   */
  function StickyNavBarButton() {
  }

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.StickyNavBarButton to the previous script.
   */
  StickyNavBarButton.noConflict = function noConflict() {
    global.NewHomeSource.StickyNavBarButton = previousStickyNavBarButton;
    return StickyNavBarButton;
  };
  if (stickyNav !== null) {
    observerStickyNavBar();
  }
  global.NewHomeSource.StickyNavBarButton = StickyNavBarButton;
}(window));
